const ConsoleLog = (text: string) => {
  const development = true;
  if (development) {
    console.log(text);
  }
};

export default ConsoleLog;
